import {
  useFlagsStatus,
  useFlag as useOriginalFlag,
  useVariant as useOriginalVariant,
} from '@unleash/nextjs';
import {
  IUseFlagReturns,
  IUseUnleashReturn,
  IUseVariantReturn,
  TFlagName,
} from '../types/UnleashContainer.types';

export const useFlag = (flagName: TFlagName): IUseFlagReturns => {
  const isEnabled = useOriginalFlag(flagName);
  const { flagsReady, flagsError } = useFlagsStatus();

  return {
    isEnabled,
    isReady: flagsReady,
    isFlagLoading: !flagsReady,
    error: flagsError,
  };
};

export const useVariant = <K extends TFlagName>(
  flagName: K
): IUseVariantReturn<K> => {
  const variant = useOriginalVariant(flagName);

  const data = variant?.payload?.value
    ? JSON.parse(variant?.payload.value)
    : null;

  return {
    ...variant,
    data,
  };
};

export const useUnleash = <K extends TFlagName>(
  flagName: K
): IUseUnleashReturn<K> => {
  const flagResponse = useFlag(flagName);
  const { data, ...variant } = useVariant<K>(flagName);

  return {
    ...flagResponse,
    ...variant,
    data,
  };
};
